<div class="w-75 h-100 m-auto">
    <div class="row" style="padding-top: 25px; padding-bottom: 25px;">
        <div class="col-md-12">
            <label class="header_text mb-3">
                {{$t('shared.addPreApprovedTemplate')}}
            </label>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-body card_body_layout">
                    <div class="row">

                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{$t('shared.templateName')}}</label>
                                <input class="form-control" v-model="model.name" type="text" />
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{$t('shared.classification')}} </label>
                                <v-select v-model="model.classification" :items="classificationList"
                                          :placeholder="$t('shared.select')" item-text="name" item-value="id" solo>
                                </v-select>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="form-group">
                                <label>{{$t('shared.description')}}</label>
                                <input class="form-control" v-model="model.description" maxlength="160" type="text" />
                                <small v-if="templateDescriptionError" class="text-danger d-block mt-1">
                                    {{ templateDescriptionError }}
                                </small>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="form-group">
                                <label>
                                    {{$t('shared.templateContent')}}
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <i class="fas fa-info-circle" v-bind="attrs" v-on="on"></i>
                                        </template>
                                        <span>
                                            <div class="mt-1">{{ $t('shared.templateVariableBoundaryInvalid') }}</div>
                                        </span>
                                    </v-tooltip>
                                </label>
                                <small class="text-muted d-block mb-1">
                                    {{ $t('shared.addVariableNote') }}
                                </small>

                                <div style="position: relative;" class="mt-1">
                                    <textarea v-model="model.templateContent"
                                              class="form-control"
                                              :style="{
                                                  border: '1px solid #000',
                                                  borderRadius: '15px',
                                                  padding: '10px',
                                                  paddingRight: '60px',
                                                  paddingTop: '12px',
                                                  boxSizing: 'border-box',
                                                  minHeight: '140px',
                                                  color: '#000'
                                              }">
                                    </textarea>

                                    <button type="button"
                                            class="btn d-inline-flex align-items-center justify-content-center text-white"
                                            @click.stop="addVariable"
                                            :title="$t('shared.addVariable')"
                                            style="position: absolute; top: 8px; right: 28px; z-index: 2; background-color: #ff3366; border-color: #ff3366; width: 1.5rem; height: 1.5rem; min-width: 1.5rem; padding: 0; border-radius: 4px; line-height: 1;">
                                        <i class="fas fa-plus" style="font-size: 0.75rem;"></i>
                                    </button>
                                </div>

                                <div class="d-flex justify-content-between mt-1">
                                    <small v-if="templateContentError" class="text-danger font-weight-bold">
                                        {{ templateContentError }}
                                    </small>
                                    <small v-else></small>
                                    <small class="text-muted">
                                        {{ $t('shared.templateCharacterCount', { count: templateContentTotalCharacterCount }) }}
                                    </small>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 pt-1" v-if="templateVariableExamples.length > 0">
                            <ul class="list-group list_Sender scrollbar mb-3">
                                <li class="list-group-item d-flex align-items-center" v-for="(example, index) in templateVariableExamples" :key="index">
                                    <span style="font-weight: bold; margin-right: 10px;">Var{{ index + 1 }}:</span>

                                    <input class="form-control form-control-sm"
                                           type="text"
                                           :value="example"
                                           @input="setVariableExample(index + 1, $event.target.value)"
                                           style="flex: 1; margin-right: 10px;" />

                                    <i class="far fa-trash-alt Icon_delete"
                                       @click="deleteVariable(index + 1)"
                                       style="cursor: pointer; color: #dc3545;"></i>
                                </li>
                            </ul>
                        </div>

                        <div class="col-md-12 mt-3">
                            <div class="form-row justify-content-end align-items-center">
                                <div class="col-auto mx-3">
                                    <router-link to="/PreApprovedTemplates" tag="a" class="link_secondary">{{$t('shared.cancel')}}</router-link>
                                </div>
                                <div class="col-auto">
                                    <button class="btn btn-success px-5 py-2" :disabled="!isValid" @click="showConfirmDialog">
                                        {{ $t('shared.save') }}
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="text-xs-center">
        <v-dialog v-model="confirmDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{ $t('shared.addInput') }}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideConfirmDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <p class="mt-3">
                        {{ $t('shared.addPreApprovedTemplateConfirm') }}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideConfirmDialog">{{$t('shared.cancel')}}</a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-success px-5 py-2" @click="save">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</div>